import * as React from 'react';
import { Route } from 'react-router';

import Layout from 'bundles/coding-challenges/components/Layout';
import loadOnRoute from 'bundles/common/components/loadOnRoute';
import NotFound from 'bundles/phoenix/components/NotFound';

const IndexPage = loadOnRoute(() => import('bundles/coding-challenges/components/CodingChallengesApp'));

export default (
  <Route path="/" component={Layout}>
    <Route path="coding-challenges" getComponent={IndexPage} />
    {/* This catch-all *, status=404 route is important for SSR. */}
    <Route path="*" component={NotFound} />
  </Route>
);
